import React from 'react';
import './Footer.css';

const Footer = ({ onNavigate }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img 
              src="https://static.wixstatic.com/media/1d90b3_588e219d6cc2449d84256529ea18235d~mv2.png" 
              alt="Digital Flourishing for Young Minds" 
              className="footer-logo"
            />
            <h4>12 Months to Flourish</h4>
            <p>Digital Flourishing for Young Minds</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h5>Programs</h5>
              <ul>
                <li><a href="#programs" onClick={(e) => { e.preventDefault(); onNavigate('programs'); }}>Teacher Professional Development</a></li>
                <li><a href="#programs" onClick={(e) => { e.preventDefault(); onNavigate('programs'); }}>Parent Workshops</a></li>
                <li><a href="#pilot" onClick={(e) => { e.preventDefault(); onNavigate('pilot'); }}>Pilot Program</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h5>Resources</h5>
              <ul>
                <li><a href="#resources" onClick={(e) => { e.preventDefault(); onNavigate('resources'); }}>Research & Evidence</a></li>
                <li><a href="#resources" onClick={(e) => { e.preventDefault(); onNavigate('resources'); }}>Implementation Guides</a></li>
                <li><a href="#resources" onClick={(e) => { e.preventDefault(); onNavigate('resources'); }}>White Papers</a></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h5>Contact</h5>
              <ul>
                <li><a href="#contact" onClick={(e) => { e.preventDefault(); onNavigate('contact'); }}>Get in Touch</a></li>
                <li><a href="#contact" onClick={(e) => { e.preventDefault(); onNavigate('contact'); }}>Schedule Consultation</a></li>
                <li><a href="#contact" onClick={(e) => { e.preventDefault(); onNavigate('contact'); }}>Support</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 12 Months to Flourish - Digital Flourishing for Young Minds. All rights reserved.</p>
          <p className="footer-mission">Technology that Serves Human Flourishing</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
